import React, { useState } from 'react';
import { searchProcessAndFlows } from './api'; // Adjust the import path as needed
import { SearchResult, SearchComponentProps } from './types'; // Adjust the import path as needed
import './styles.css'; // Ensure you import the CSS file

const SearchComponent: React.FC<SearchComponentProps> = ({ onResultSelect }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [results, setResults] = useState<SearchResult[]>([]); // Use the SearchResult interface
  const [showModal, setShowModal] = useState(false);

  const handleSearch = async () => {
    if (searchTerm.trim()) {
      try {
        const searchResults = await searchProcessAndFlows(searchTerm);
        setResults(searchResults);
        setShowModal(true);
      } catch (error) {
        console.error('Error searching:', error);
      }
    }
  };

  return (
    <div className="search-container">
      <input
        type="text"
        className="search-input"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        placeholder="Search for a product or process..."
      />
      <button className="search-btn" onClick={handleSearch}>Search</button>
      {showModal && (
        <div className="modal">
          

{showModal && (
  <div className="modal-overlay">
    <div className="modal-content">
      {/* Scrollable content */}
      <div className="modal-scroll-content">
        <table>
          <thead>
            <tr>
              <th>Process</th>
              <th>Producing</th>
              <th>From</th>
              <th>Select</th>
            </tr>
          </thead>
          <tbody>
            {results.map((result, index) => (
              <tr key={index}>
                <td>{result.PROCESS}</td>
                <td>{result.PRODUCING.join(', ')}</td>
                <td>{result.FROM.join(', ')}</td>
                <td>
                  <button onClick={() => {
                    onResultSelect(result);
                    setShowModal(false);
                  }}>
                    Select
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Close button */}
      <div className="close-btn-container">
        <button onClick={() => setShowModal(false)}>Close</button>
      </div>
    </div>
  </div>
)}


        </div>
      )}
    </div>
  );
};

export default SearchComponent;
